import { FovErrorType, FovPageType } from '@contentsquare/fov-constants';
import { JSErrorLabelHelper } from './error-label-js.helper';
import { APIErrorLabelHelper } from './error-label-api.helper';
import { CustomErrorLabelHelper } from './error-label-custom.helper';
import { pageOptions, errorExperienceOptions } from './error-condition-options-list';
export class ErrorsTextExtractorHelper {
    /**
     * @param featurePofAc feature flag to be removed after AC has deployed the POF update
     */
    constructor(translate, featurePofAc = false) {
        this.translate = translate;
        this.featurePofAc = featurePofAc;
    }
    getText(errorFilter) {
        const pageOptionLabel = this.getPageOptionLabel(errorFilter);
        const errorLabel = this.getErrorLabel(errorFilter);
        const experienceLabel = this.getErrorExperienceOptionLabel(errorFilter);
        const errorHasMultiClicks = this.getErrorExperienceMultiClicks(errorFilter);
        const text = `${this.translate('ANALYSIS_CONTEXT.ERROR_CONDITION.USERS_VISITED_ERRORS')}` +
            ` ${pageOptionLabel}` +
            ` ${this.translate('ANALYSIS_CONTEXT.ERROR_CONDITION.AND')}` +
            ` ${experienceLabel}` +
            ` ${errorLabel} ` +
            ` ${errorHasMultiClicks} `;
        return text;
    }
    getErrorLabel(errorFilter) {
        const { errorType } = errorFilter.value;
        switch (errorType) {
            case FovErrorType.JS:
                const jsHelper = new JSErrorLabelHelper(this.translate);
                return jsHelper.getJSErrorLabel(errorFilter);
            case FovErrorType.API:
                const apiHelper = new APIErrorLabelHelper(this.translate);
                return apiHelper.getAPIErrorLabel(errorFilter);
            case FovErrorType.CUSTOM:
                const customHelper = new CustomErrorLabelHelper(this.translate);
                return customHelper.getCustomErrorLabel(errorFilter);
        }
    }
    getPageOption(errorFilter) {
        const { pageOption } = errorFilter.value;
        const selectedPageOption = pageOptions.find((item) => item.value === pageOption);
        return selectedPageOption;
    }
    getPageOptionLabel(errorFilter) {
        const { pageOption, pageUrl, pageId, pageName } = errorFilter.value;
        const selectedPageOption = this.getPageOption(errorFilter);
        const label = selectedPageOption === null || selectedPageOption === void 0 ? void 0 : selectedPageOption.label;
        switch (pageOption) {
            case FovPageType.ANY: {
                return this.translate(label);
            }
            case FovPageType.PAGE: {
                if (pageId) {
                    return this.featurePofAc
                        ? `${this.translate(label)} <mappings-page-label page=${JSON.stringify({
                            id: pageId,
                        })}></mappings-page-label>`
                        : `${this.translate(label)} ${pageName}`;
                }
                break;
            }
            case FovPageType.URL: {
                return `${this.translate(label)} ${pageUrl}`;
            }
        }
    }
    getErrorExperienceOption(errorFilter) {
        const { experienceOption } = errorFilter.value;
        const selectedExperienceOption = errorExperienceOptions.find((item) => item.value === experienceOption);
        return selectedExperienceOption;
    }
    getErrorExperienceOptionLabel(errorFilter) {
        const selectedExperienceOption = this.getErrorExperienceOption(errorFilter);
        const label = selectedExperienceOption === null || selectedExperienceOption === void 0 ? void 0 : selectedExperienceOption.label;
        return this.translate(label);
    }
    getErrorExperienceMultiClicks(errorFilter) {
        const { errorHasMultipleClicks } = errorFilter.value;
        const label = ` ${this.translate('ANALYSIS_CONTEXT.ERROR_CONDITION.AND')}` +
            ` ${this.translate('ANALYSIS_CONTEXT.ERROR_CONDITION.USER_EXPERIENCED_MULTIPLE_CLICKS')}`;
        return errorHasMultipleClicks ? label : '';
    }
}
//# sourceMappingURL=errors-text-extractor.helper.js.map